export default __webpack_public_path__ + "search-examples-mapbox-mapview-category-960-e8f8dc61cf4c2d8a9092bfbc0af7cbbc.webp";